import { useEffect, useState } from 'react'
import { useDispatch } from "react-redux"
import { push } from "connected-react-router"
import styled from 'styled-components'
import { Layout } from '../components'
// Firebase
import { db } from '../firebase'
// Mui
import Button from "@material-ui/core/Button"
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}

const MagazineManager = () => {

    const dispatch = useDispatch()
    const [magazines, setMagazines] = useState([])
    const [showOnly, setShowOnly] = useState('')

    const FilteredTableRow = props => {
        const magazine = props.magazine
        return (
            <TableRow hover style={{cursor: 'pointer'}} key={magazine.id} onClick={()=>dispatch(push('/magazine/edit/' + magazine.id))}>
                <TableCell>{magazine.isDraft === true ? '下書き' : '公開中'}</TableCell>
                <TableCell>{magazine.title}</TableCell>
                <TableCell>{magazine.created_at ? dateTimeToString(magazine.created_at.toDate()) : ""}</TableCell>
            </TableRow>
        )
    }

    useEffect(()=>{
        db.collection('magazines').orderBy('created_at','desc').get()
          .then(snapshots=>{
                const temprList = []
                snapshots.forEach(snapshot => {
                    temprList.push(snapshot.data())
                })
                setMagazines(temprList)
          })
    },[])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>マガジン管理</h1>
            <div className='spacer-50' />

            <div style={{textAlign: 'center'}}>
            <Button color={'primary'} onClick={()=>dispatch(push('/magazine/edit'))}>新規マガジン投稿</Button>
                <Button onClick={()=>setShowOnly('')}>マガジン一覧</Button>
                <Button onClick={()=>setShowOnly('ゴミ箱')}>ゴミ箱</Button>
            </div>
            <div className='spacer-50' />

            <Wrapper>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ステータス</TableCell>
                                <TableCell>タイトル</TableCell>
                                <TableCell>投稿日</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {magazines.map(magazine=>{
                                if (showOnly === 'ゴミ箱') {
                                    return magazine.isTrash === true ? <FilteredTableRow magazine={magazine} /> : false
                                } else {
                                    return magazine.isTrash !== true ? <FilteredTableRow magazine={magazine} /> : false
                                }
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Wrapper>
            <div className='spacer-100' />
        </Layout>
    )
}
export default MagazineManager

const Wrapper = styled.div`
    width: 960px;
    margin: 0 auto;
`